import type { IconData } from '@stacksjs/iconify-core'

export const disqusSquare: IconData = {
  "body": "<g fill=\"currentColor\"><path d=\"M10.172 14.665a4.88 4.88 0 0 1-3.116-1.113l-2.068.271l.797-1.903a4.5 4.5 0 0 1-.433-1.944c0-2.59 2.159-4.689 4.819-4.689c2.664 0 4.82 2.099 4.82 4.689s-2.156 4.689-4.82 4.689zm.03-7.19H8.426v5.001h1.751c1.657 0 2.625-1.072 2.625-2.514v-.013c0-1.442-.956-2.474-2.6-2.474\"/><path d=\"M11.491 9.979c0 .81-.506 1.267-1.27 1.267h-.519V8.702h.519c.764 0 1.27.464 1.27 1.264z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default disqusSquare
